import facebookIcon from "@iconify/icons-akar-icons/facebook-fill";
import instagramIcon from "@iconify/icons-akar-icons/instagram";
import linkedinIcon from "@iconify/icons-brandico/linkedin";
import youtubeIcon from "@iconify/icons-ant-design/youtube-outlined";

export const SOCIAL_MEDIAS = (language: string) =>
  language === "en" || language === "de"
    ? [
        {
          name: "Facebook",
          icon: facebookIcon,
          href: "https://www.facebook.com/rendprolimited",
        },
        {
          name: "Instagram",
          icon: instagramIcon,
          href: "https://www.instagram.com/rendprolimited",
        },
        {
          name: "YouTube",
          icon: youtubeIcon,
          href: "https://www.youtube.com/@RendProLimited",
        },
        {
          name: "Linkedin",
          icon: linkedinIcon,
          href: "https://linkedin.com/company/rendpro",
        },
        // { name: "Dribbble", icon: dribbleIcon, href: "https://dribbble.com" },
      ]
    : [
        {
          name: "Facebook",
          icon: facebookIcon,
          href: " https://www.facebook.com/Rendprocom",
        },
        {
          name: "Instagram",
          icon: instagramIcon,
          href: "https://www.instagram.com/rendprocom/",
        },
        {
          name: "YouTube",
          icon: youtubeIcon,
          href: "https://www.youtube.com/channel/UCn9fS3ObuUVEXbPW3urE8Ug",
        },
        {
          name: "Linkedin",
          icon: linkedinIcon,
          href: "https://linkedin.com/company/rendpro",
        },
        // { name: "Dribbble", icon: dribbleIcon, href: "https://dribbble.com" },
      ];

export const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PHONE_PATTERN =
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/;
